<template>
  <modal-card ref="modal">
    <ul class="is-spaced">
      <li>
        <button class="button is-default is-fullwidth is-block" @click="handleResetPassword()">
          Reset Password
        </button>
      </li>
      <li>
        <!--Set Admin Status-->
        <button class="button is-default is-fullwidth is-block" @click="setAdmin(false)" v-if="user.isAdmin">
          Remove Admin Status
        </button>
        <button class="button is-default is-fullwidth is-block" @click="setAdmin(true)" v-else>
          Make Admin
        </button>
      </li>
      <li>
        <button class="button is-danger is-fullwidth is-block" @click="handleDeleteUser()">
          Delete User
        </button>
      </li>
    </ul>
  </modal-card>
</template>

<script>
import { resetUserPasswordMutation, deleteUserMutation, setAdminMutation } from '../../graphql/users'
import ModalCard from '../ModalCard.vue'

export default {
  components: {
    ModalCard
  },
  props: {
    user: Object
  },
  methods: {
    /*
     * Set Admin Status
     */
    setAdmin (isAdmin) {
      // create the appropriate message
      let message = ''
      if (isAdmin) {
        message = `Are you sure that you want make ${this.user.email} an Admin?`
      } else {
        message = `Are you sure that you want to remove Admin status from ${this.user.email}`
      }
      // run the mutation
      this.$dialog.confirm({
        message,
        onConfirm: () => {
          // reset action
          this.$apollo.mutate({
            mutation: setAdminMutation,
            variables: {
              id: this.user.id,
              isAdmin: !!isAdmin
            }
          })
            .then(() => {
              this.$toast.open({
                message: 'Admin status updated',
                type: 'is-success'
              })
              // close modal
              this.$refs.modal.close()
            })
            .catch((e) => {
              this.$toast.open({
                message: 'Failed to update admin status!<br>' + (e.message || e),
                type: 'is-danger',
                duration: 5000
              })
            })
        }
      })
    },

    /*
     * Reset password via Cognito
     */
    handleResetPassword () {
      this.$dialog.confirm({
        message: `Are you sure that you want to reset the password for ${this.user.email}`,
        onConfirm: () => {
          // reset action
          this.$apollo.mutate({
            mutation: resetUserPasswordMutation,
            variables: {
              id: this.user.id
            }
          })
            .then(() => {
              this.$toast.open({
                message: 'Password reset!',
                type: 'is-success'
              })
              // close modal
              this.$refs.modal.close()
            })
            .catch((e) => {
              this.$toast.open({
                message: 'Failed to reset password!<br>' + (e.message || e),
                type: 'is-danger',
                duration: 5000
              })
            })
        }
      })
    },

    /*
     * Delete a User
     */
    handleDeleteUser () {
      this.$dialog.confirm({
        message: `Are you sure that you want to delete the user ${this.user.email}`,
        onConfirm: () => {
          // reset action
          this.$apollo.mutate({
            mutation: deleteUserMutation,
            variables: {
              id: this.user.id
            }
          })
            .then(() => {
              this.$toast.open({
                message: 'User deleted',
                type: 'is-success'
              })
              // notify the parent of the action
              this.$emit('delete')
              // close modal
              this.$refs.modal.close()
            })
            .catch((e) => {
              this.$toast.open({
                message: 'Failed to delete user!<br>' + (e.message || e),
                type: 'is-danger',
                duration: 5000
              })
            })
        }
      })
    }
  }
}
</script>
